// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ImportUpdateClientSchema = z.object({
  client: z.object({
    external_id: z.coerce.string().describe("External ID from the integration system"),
  }),
});
